module.exports = __webpack_public_path__ + "images/powered_by_soundcloud.png?f2595";